module.exports = __webpack_public_path__ + "static/media/PF-009-1Skimmer.a5faaa11.png";